import { styled, Typography } from "@mui/material";

export const topListBoxStyles = { marginBottom: "15px" };

export const dividerStyles = { margin: 0 };
export const imageDividerStyles = { margin: "2em 0 3em 0" };

export const DeviceInfoBoxSC = styled("div")(
  () => `
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  min-height: 105px;
`
);

export const NoDeviceInfoBoxSC = styled("div")(
  () => `
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`
);

export const DeviceNameBoxSC = styled("div")(
  () => `
  display: flex;
  flex-direction: row;
  height: 100px;
  flex: 2;
  align-items: center;
`
);

export const CommentBoxSC = styled("div")(
  () => `
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-content: center;
`
);

export const BasicTileActionButtonWrapperSC = styled("div")({ display: "flex", alignSelf: "flex-end", gap: "1rem" });

export const BatteryListItemSC = styled("div")(
  () => `
  display: flex;
  flex: 2;
  align-items: center;
`
);

export const ListLabelSC = styled(Typography)(
  () => `
font-family: var(--copytext-font-family-bold);
font-size: var(--copytext-font-size);
flex: 1;
`
);
